export const defaultMargin = '25px'

export const input = {
    desktop: {
        padding: '13px',
        marginTop: defaultMargin,
        marginBottom: defaultMargin,
    },
    mobile: {},
}

export const fontSize = {
    label: {
        desktop: '14px',
    },
    paragraph: {
        desktop: '14px',
    },
}

export const errors = {
    default_required_key: 'required_field',
    default_interval_t_key: 'invalid_amount_or_interval',
    default_at_least_one_choice: 'required_acp_impact_selection',
}

export const desktopThreshold = 900
export const mobileMaxWidth = `${desktopThreshold}px`
